import createRoute from '@widesk-ui/tools/createRoute';
import CartModel   from '@models/shop/CartModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/carts', 'shop', 'CartDashboard', CartModel.localize());
